<script>
  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-stores
  import { page } from "$app/stores";
  import { GridContainer } from "@ObamaFoundation/of-design-system";
  import Seo from "$lib/components/SEO.svelte";
  import PageBody from "$lib/components/Page/PageBody.svelte";

  const PAGE_DATA = {
    fields: {
      headline: "404 Page"
    }
  };

  $: currentUrl = $page.error.url;
</script>

<Seo data={PAGE_DATA.fields} {currentUrl} errorPage />

{#if $page.error.pageData}
  <PageBody body={$page.error.fields.body} class="page-body last-page-element" />
{:else}
  <!-- We really don't want this to happen, but what if they move the error page? -->
  <GridContainer>
    <div class="text-center">
      <h1 class="heading-md">Oops, an error has occurred.</h1>
      <p class="body-lg">{$page.error.message}: {currentUrl}</p>
    </div>
  </GridContainer>
{/if}
